import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import { Form, Checkbox, Card, Input } from 'antd';
import Lottie from 'lottie-react';

export const CenterWrapper = styled.section`
	/* overflow: hidden;
	display: flex;
	justify-content: center; 
	align-items: center;
	height: 100vh; */
	overflow: hidden;
	display: flex;
	justify-content: center;
	flex: auto;
	flex-direction: column;
	height: 100vh;

	@media only screen and (max-width: 992px) {
		width: 100%;
		position: relative;
		display: block !important;
		height: 100%;
	}
	@media only screen and (min-width: 2000.99px) {
		display: block !important;
	}
`;
export const Logo = styled.div`
	width: 100%;
	position: relative;
	@media only screen and (max-width: 992px) {
		text-align: center;
	}
	&.mobileLogo {
		display: none;
		margin: 30px 0px;
		text-align: left;
		@media only screen and (max-width: 992px) {
			display: block;
			img {
				max-width: 150px;
			}
		}
	}
`;
export const Title = styled.h1`
	margin: 0px;
	font-style: normal;
	font-weight: 400;
	font-size: 36px;
	line-height: 46px;
	color: ${({ theme }) => theme.colors.themeColor1};
	@media only screen and (max-width: 768px) {
		text-align: center;
		font-size: 20px;
		line-height: 26px;
	}
`;
export const XForm = styled(Form)`
	label {
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		font-style: normal;
		font-size: 14px !important;
		font-weight: 400;
		line-height: 21px;
		line-height: normal;
	}
	input {
		background: ${({ theme }) => theme.colors.themeColor26} !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor28} !important;
		border-radius: 10px;
		height: 50px;
		&:hover,
		&:focus,
		&:active {
			background: ${({ theme }) => theme.colors.themeColor26};
			border: 1px solid ${({ theme }) => theme.colors.themeColor28};
		}
		@media only screen and (max-width: 768px) {
		}
	}
	.ant-input-outlined:hover,
	.ant-input-outlined:focus,
	.ant-input-outlined:active {
		background: ${({ theme }) => theme.colors.themeColor26};
		border: 1px solid ${({ theme }) => theme.colors.themeColor28};
	}
	/* button {
		width: 100%;
		border-radius: 50px !important;
		background: #007299;
		color: #fff;
		font-size: 16px !important;
		padding: 10px 0px;
		height: auto;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
		&:hover {
			background: #007299 !important;
			color: #fff !important;
		}
		@media only screen and (max-width: 768.99px) {
			font-size: 14px;
			padding: 10px 0px;
		}
	} */
	.ant-input-password {
		background: ${({ theme }) => theme.colors.themeColor26} !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor28} !important;
		border-radius: 10px;
		height: 50px;
		input {
			height: 38px !important;
			line-height: 30px;
			background: ${({ theme }) => theme.colors.themeColor26} !important;
			border: none !important;
			&:hover,
			&:focus,
			&:active {
				background: ${({ theme }) =>
					theme.colors.themeColor26} !important;
				border: none !important;
			}
		}

		@media only screen and (max-width: 992px) {
		}
	}
	.login-form-forgot {
		float: right;
		text-decoration: none;
		color: ${({ theme }) => theme.colors.themeColor1};
		text-align: right;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		@media only screen and (max-width: 992px) {
			font-size: 14px;
			line-height: 22px;
		}
	}
`;
export const XThemeLottieCard = styled(Card)`
	width: 100%;
	position: relative;
	margin: 0px auto;
	background: #f8f8f8;
	border-radius: 50px;
	border: none;
	text-align: center;
	.ant-card-body {
		padding: 0px;
	}
	&.mobileCard {
		@media only screen and (max-width: 992px) {
			background: ${({ theme }) => theme.colors.white};
			border-radius: 20px;
		}
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XLottie = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 75%;
	margin: 0px auto;
	@media only screen and (max-width: 768px) {
		width: 75%;
		position: relative;
		margin: 0px auto;
	}
`;
export const XCheckbox = styled(Checkbox)`
	color: ${({ theme }) => theme.colors.themeColor1};
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;
export const XCustomFloatLabel = styled.div`
	position: relative;
	background: transparent;
	height: 60px;
	.floatingLabel {
		position: absolute;
		background: ${({ theme }) => theme.CQColors.bodyBg};
		top: -8px;
		left: 5px;
		z-index: 99;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		font-size: 14px;
		font-weight: 400;
		padding: 0px 5px;
	}
	.floatingInput {
		.ant-input-password {
			padding-left: 0px !important;
			input {
				min-height: 48px;
				padding: 20px 15px 15px 15px;
			}
		}
		input {
			border-radius: 0px !important;
			padding: 20px 15px 15px 15px;
		}
		.ant-input-password {
			border-radius: 0px !important;
			padding: 0px 10px;
		}
	}
`;
